import React from 'react';

import { ArrowRight } from 'lucide-react';

import EmptyBoxIcon from '@/assets/icons/empty-box.svg?react';
import { Button } from '@/components/atoms/new-button';

interface EmptyStateCreationProps {
  title: string;
  onClick: () => void;
  subtitle?: string;
  icon?: React.ReactNode;
}

const EmptyStateCreation = ({
  title,
  subtitle,
  onClick,
  icon = <EmptyBoxIcon className="h-16 w-16 text-gray-600" />,
}: EmptyStateCreationProps) => {
  return (
    <div className="flex w-full justify-center py-4" data-testid="empty-state">
      <div className="relative w-full rounded-lg border border-dashed border-gray-200 px-6 py-12 text-center">
        {/* Background decorative element */}
        <div className="absolute inset-0 rounded-lg bg-gray-50"></div>

        {/* Content */}
        <div className="relative flex flex-col items-center gap-4">
          {/* Text content */}
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-lg font-medium text-gray-700">{title}</h3>
            {subtitle && <div className="text-sm leading-relaxed text-gray-400">{subtitle}</div>}
          </div>

          {/* Action button */}
          <Button variant="primary" size="sm" onClick={onClick}>
            Start
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyStateCreation;
